import Lottie from 'react-lottie';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: -8px;
`;

export const LottieWrapper = styled(Lottie)`
  display: block;
`;
